import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { PsdiService } from 'src/app/services/service.index';


declare var toastr;


@Component({
  selector: 'app-psdi',
  templateUrl: './psdi.component.html',
  styles: []
})
export class PsdiComponent implements OnInit {  
  
    @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
    dataResourcePR: any[];
    model: any = {
      id: 0,
      codigo: '',
      descripcion: '',
      activo: true
    };
    psdiId: number;
    popupVisibleAdd: boolean = false;
    popupVisibleDel: boolean = false;
    state_toogle: boolean = false;
    vigencia: any[];
    baseUrl = environment.apiEndpoint;
    hasError: any;
  
    constructor(private _ss: PsdiService) {
      this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];
      this.clearErrors();
      this.getPsdi();
    }
  
    ngOnInit() {
    }
  
    clearErrors() {
      this.hasError = { codigo: false, descripcion: false };
    }
  
    getPsdi() {
      this._ss.getPsdiActivo().subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.dataResourcePR = result.data;
          } else {
            this.dataResourcePR = [];
          }
        },
        (error) => {
          console.log('Error', error);
        });
    }
  
    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: 'before',
        template: 'acciones'
      });
    }
  
    showModalAdd() {
      this.clearErrors();
      this.model.id = 0;
      this.model.codigo = '';
      this.model.descripcion = '';
      this.model.activo = true;
      this.state_toogle = false;
      this.popupVisibleAdd = true;
    }
  
    showModalEdit(data: any) {
      this.clearErrors();
      this.model.id = data.id;
      this.model.codigo = data.codigo;
      this.model.descripcion = data.descripcion;
      this.model.activo = data.activo;
      this.state_toogle = true;
      this.popupVisibleAdd = true;
    }
  
    savePsdi() {
      this.hasError = { codigo: false, descripcion: false };
      if (this.validate(this.model)) {
        if (this.model.id == 0) {          
          this._ss.postPsdi(this.model).subscribe(
            response => {
              let result = UtilHelper.responses(response);
              if (result.status == 200) {
                this.getPsdi();
                this.popupVisibleAdd = false;
                toastr.success('Psdi adicionado exitosamente.');
              } else {
                toastr.warning(result.data);
              }
            },
            error => { console.log('Error', error); });
        }
        else {
          this._ss.putPsdi(this.model).subscribe(
            response => {
              let result = UtilHelper.responses(response);
              if (result.status == 200) {
                this.getPsdi();
                this.popupVisibleAdd = false;
                toastr.success('Psdi modificado exitosamente.');
              } else {
                toastr.warning(result.data);
              }
            },
            error => { console.log('Error', error); });
        }
      }
    }
  
    showModalDelete(id: number) {
      this.psdiId = id;
      this.popupVisibleDel = true;
    }
  
    deleteOdes() {
      this._ss.deletePsdi(this.psdiId).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getPsdi();
            this.popupVisibleDel = false;          
            toastr.success('Proceso realizado correctamente.');          
          } else {           
            this.getPsdi();   
            this.popupVisibleDel = false;          
            toastr.warning(result.data);   
          }
        },
        error => { console.log('Error', error); });
    }
  
    validate(data: any) {
      let res = true;
      if (!UtilHelper.validator(data.codigo, 'text')) {
        this.hasError.codigo = true; res = false;
      }
      if (!UtilHelper.validator(data.descripcion, 'text')) {
        this.hasError.descripcion = true; res = false;
      }
      return res;
    }
  }
  